import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=0a6f3896&scoped=true&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=0a6f3896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6f3896",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/l-setting-for-configuration-tool/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a6f3896')) {
      api.createRecord('0a6f3896', component.options)
    } else {
      api.reload('0a6f3896', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=0a6f3896&scoped=true&", function () {
      api.rerender('0a6f3896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/auth/components/ChangePassword.vue"
export default component.exports